import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Directive({
  selector: '[appLet]'
})
export class LetDirective<T> {
  private subscription: Subscription | null = null; // Subscription to the observable
  private context: { $implicit: T | null; appLet: T | null } = { $implicit: null, appLet: null }; // Context

  constructor(
    private viewContainer: ViewContainerRef, // Manages the rendered view
    private templateRef: TemplateRef<any> // Template to render
  ) {}

  @Input()
  set appLet(source$: Observable<T> | null) {
    // Cleanup existing subscriptions
    this.clearSubscription();

    // If a new observable is provided, subscribe to it
    if (source$) {
      this.subscription = source$.subscribe({
        next: (value: T) => {
          this.updateView(value); // Update view with emitted value
        },
        error: () => {
          this.updateView(null); // In case of error, clear value
        }
      });
    }
  }

  // Update the context and re-render the template
  private updateView(value: T | null): void {
    this.context.$implicit = value; // Default for `let` shorthand
    this.context.appLet = value; // Explicit reference
    this.viewContainer.clear(); // Clear the current view
    this.viewContainer.createEmbeddedView(this.templateRef, this.context); // Re-render the view
  }

  // Clear any active subscriptions
  private clearSubscription(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  ngOnDestroy(): void {
    this.clearSubscription();
  }
}
